import React from 'react'
import { Modal, Spin } from 'antd'
import { PharmacySearchForm } from './PharmacySearchForm'

export const ChangePharmacyModal = ({
    visible,
    onCancel,
    pharmacySearchResults,
    pharmacySpecialtyTypes,
    pharmacySearchLoading,
    searchPharmacies,
    selectPharmacy,
    handleCancelSearch
}) => {
    return (
        <Modal
            open={visible}
            title="Change Pharmacy"
            onCancel={onCancel}
            footer={null}
            width={600}
        >
            <Spin spinning={pharmacySearchLoading}>
                <PharmacySearchForm
                    pharmacySearchResults={pharmacySearchResults}
                    pharmacySpecialtyTypes={pharmacySpecialtyTypes}
                    searchPharmacies={searchPharmacies}
                    selectPharmacy={selectPharmacy}
                    handleCancelSearch={handleCancelSearch}
                />
            </Spin>
        </Modal>
    )
}
